/**
 * liveBubblePolicy — cuándo un `agent_message` cierra la burbuja viva (#1130).
 *
 * Vive aquí, y no inline en cada consumidor, porque la regla se aplica en las
 * DOS máquinas de sesión del chat (`Chat.jsx` y `useModularChat.ts`) y ya se
 * arregló una vez en una sola: #1017 §1 lo corrigió en el hook modular, el chat
 * principal se quedó con la llamada fuera del `if`, y el comentario del arreglo
 * afirmaba que copiaba una línea de `Chat.jsx` que no existía. Mismo motivo por
 * el que `scrollPolicy.js` está en esta carpeta.
 *
 * Lo que está en juego no es cosmético: cerrar la burbuja arma además el
 * lockout de ~250 ms contra deltas rezagados, y ese lockout DESCARTA los
 * `stream-delta` que lleguen dentro de la ventana. Cerrarla con un mensaje
 * intermedio no repinta texto: lo pierde.
 */

/**
 * ¿Este `agent_message` es el que termina el turno?
 *
 * Los motores que emiten intermedios a mitad de turno (Onboarding, Planner) los
 * marcan con `isIntermediateMessage: true` — lo sella el backend en
 * `webhookController` al reenviar el payload. Un payload sin el campo es final:
 * es la forma que tienen los motores que solo mandan la respuesta definitiva.
 *
 * @param {{ isIntermediateMessage?: boolean } | null | undefined} payload
 * @returns {boolean} true si debe cerrarse la burbuja viva (y armarse el lockout)
 */
export function isFinalAgentMessage(payload) {
  return !payload?.isIntermediateMessage;
}
